




























import Vue from 'vue';
import { ServiceTile } from '@/requests/mainApi/models/ServiceTile';
import { ThisTypedComponentOptionsWithRecordProps } from 'vue/types/options';
import Service from './Service.vue';
import UiModal from '@/components/ui/UiModal.vue';
import { mapActions, mapGetters, mapMutations } from 'vuex';
import { storeModuleName } from '@/views/App/Profile/store';
import { CatalogItem } from 'src/requests/mainApi/models';
import { CatalogV1ItemMyListRequest } from 'src/requests/mainApi';

interface Data {
  services: ServiceTile[];
}

interface Methods {
  setServiceModalOpen: () => void;
  sendToMetrics: (key: string) => void;
  setPPDAndTPDConfirmModalOpen: (state: boolean) => void;
  getMyFinishedFlats: (payload: CatalogV1ItemMyListRequest) => Promise<CatalogItem[]>;
}

interface Computed {
  loadingFinishedFlats: boolean;
  myFinishedFlats: CatalogItem[];
}

interface Props {}

export default Vue.extend({
  name: 'Services',
  components: {
    Service,
    UiModal,
  },
  data() {
    return {
      modalIsOpen: false,
      services: [
        {
          id: 1,
          title: this.$t('app.profile.flatsList.servicesTiles.evaluate'),
          // eslint-disable-next-line no-undef
          imgSrc: require('@/assets/services/loupe.png'),
          metricKey: 'ocenka',
        },
        {
          id: 2,
          title: this.$t('app.profile.flatsList.servicesTiles.concession'),
          // eslint-disable-next-line no-undef
          imgSrc: require('@/assets/services/handshake.png'),
          metricKey: 'ustupka',
        },
        {
          id: 3,
          title: this.$t('app.profile.flatsList.servicesTiles.register'),
          // eslint-disable-next-line no-undef
          imgSrc: require('@/assets/services/document.png'),
          metricKey: 'reg_pravo',
        },
        {
          id: 4,
          title: this.$t('app.profile.flatsList.servicesTiles.accept'),
          // eslint-disable-next-line no-undef
          imgSrc: require('@/assets/services/calendar.png'),
          metricKey: 'zapic',
        },
        {
          id: 5,
          title: this.$t('app.profile.flatsList.servicesTiles.tradeIn'),
          // eslint-disable-next-line no-undef
          imgSrc: require('@/assets/services/houses.png'),
          metricKey: 'treid-in',
        },
        {
          id: 6,
          title: this.$t('app.profile.flatsList.servicesTiles.video'),
          // eslint-disable-next-line no-undef
          imgSrc: require('@/assets/services/video.png'),
          metricKey: 'video_kvartir',
        },
      ],
    };
  },
  computed: {
    ...mapGetters(storeModuleName, ['myFinishedFlats', 'loadingFinishedFlats', 'myFlats']),
  },
  async created() {
    this.getMyFinishedFlats({
      building_state: 'hand-over',
    });
  },
  methods: {
    ...mapMutations(['setServiceModalOpen']),
    sendToMetrics(key: string) {
      // @ts-ignore
      this.$metrika.reachGoal(key);
    },
    ...mapMutations(['setServiceModalOpen', 'setPPDAndTPDConfirmModalOpen']),
    ...mapActions(['getBasisWidgetToken']),
    ...mapActions(storeModuleName, ['getMyFinishedFlats']),
  },
} as ThisTypedComponentOptionsWithRecordProps<Vue, Data, Methods, Computed, Props>);
